module.exports = __webpack_public_path__ + "img/logo6.cd068b79.png";